import { useState, useEffect } from "react";
import { BiCookie } from "react-icons/bi";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function CookiePopup() {
  const [showPopup, setShowPopup] = useState(false);

  const { t } = useTranslation("global");

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsentGiven");
    if (consent !== "true") {
      setShowPopup(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsentGiven", "true");
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 1 }}
      className="fixed top-0 left-0 w-screen h-screen bg-black backdrop-blur-sm bg-opacity-50 z-[10000]"
    >
      <div className="relative w-screen h-screen">
        <div className="absolute flex flex-col items-center top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-50 bg-white rounded-2xl shadow-intense px-6 py-16 text-white w-[90%] lg:w-[500px]">
          <div className="bg-gray-400 rounded-full w-24 h-24 mb-8 flex items-center justify-center">
            <BiCookie className="text-[70px] text-white" />
          </div>

          <p className="text-3xl font-bold text-black mb-6">
            {t("cookiePopup.title")}
          </p>

          <p className="text-lg text-center text-black/70 mb-10">
            {t("cookiePopup.content1")}
          </p>
          <button
            onClick={handleAccept}
            className="bg-navyBlue text-white px-14 py-3 text-[17px] rounded-full font-semibold hover:scale-105 transition-all"
          >
            {t("cookiePopup.btn1")}
          </button>
        </div>
      </div>{" "}
    </motion.div>
  );
}
